module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "temp_div"
  }, [_c('img', {
    staticClass: "temp_img",
    attrs: {
      "src": "http://www.tjhzs.com/images/tjhzs_2021_12_15.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tjhzs_about tjhzs-main-content"
  }, [_c('section', {
    staticClass: "about_list"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.getHtml(_vm.info[1].content))
    }
  }, [_vm._v(_vm._s(_vm.getHtml(_vm.info[1].content)))]), _vm._v(" "), _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.info[0].title))])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.getHtml(_vm.info[0].content))
    }
  }, [_vm._v(_vm._s(_vm.getHtml(_vm.info[0].content)))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('job-head', {
    attrs: {
      "contact": _vm.contact
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "job_img",
    attrs: {
      "src": "http://www.tjhzs.com/images/tjhzs_2021_12_15_2.jpg"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "about_list about_weal"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("我们的福利")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "conrow"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "icon-house icons"
  }), _vm._v(" "), _c('span', [_vm._v("提供工作住房")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "icon-travel icons"
  }), _vm._v(" "), _c('span', [_vm._v("一周团队旅行")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "icon-film icons"
  }), _vm._v(" "), _c('span', [_vm._v("工作娱乐两不误")])])]), _vm._v(" "), _c('div', {
    staticClass: "conrow"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "icon-learn icons"
  }), _vm._v(" "), _c('span', [_vm._v("学习+加薪")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "icon-money icons"
  }), _vm._v(" "), _c('span', [_vm._v("工龄福利丰厚")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "icon-heart icons"
  }), _vm._v(" "), _c('span', [_vm._v("超越年假的探亲假")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weixin"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/weixin.02fbb77.png",
      "alt": "weixin"
    }
  }), _vm._v(" "), _c('p', [_vm._v("我们的公众号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-596b0c67!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/About.vue
// module id = 181
// module chunks = 1